import { mediaQuery } from 'constants/ui';

export const contentStyles = {
  flex: 1,
  overflowY: 'auto',
  padding: '16px 16px 0',
  position: 'relative',
  [mediaQuery.mobile]: {
    padding: '12px 12px 0',
  },
};

export const messagesContainerStyles = {
  flex: 1,
  overflow: 'auto',
  display: 'flex',
  flexDirection: 'column',
  scrollbarWidth: 'none',
  '&::-webkit-scrollbar': {
    display: 'none',
  },
};

export const messagesInnerContainerStyles = {
  display: 'flex',
  flexDirection: 'column',
  gap: '12px',
};

export const messagesSpacerStyles = {
  flexGrow: 1,
};

export const scrollToBottomButtonStyles = {
  position: 'absolute',
  right: '16px',
  bottom: '16px',
  width: '32px',
  height: '32px',
  backgroundColor: ({ palette }) => palette.background.paper,
  color: ({ palette }) => palette.text.dark,
  boxShadow: ({ palette }) => palette.shadow.m,
  '&:hover': {
    backgroundColor: ({ palette }) => palette.background.paper,
  },
  [mediaQuery.mobile]: {
    right: '12px',
    bottom: '12px',
  },
};
